import React, { useState, useEffect, useRef } from "react";
import { Animate } from "react-move";

interface AnimatedProps {
    repeat: boolean,
    duration: number,
    valueStart: number,
    valueEnd: number,
    easing: (arg: number) => number,
    children: (arg: any) => JSX.Element,
}

export default function AnimatedProgressProvider({ duration, valueStart, valueEnd, easing, children }: AnimatedProps): JSX.Element {
    const [isAnimated, setState] = useState(false);
    const inputEl = useRef(null);

    useEffect(() => {
        setState(!isAnimated);
        // eslint-disable-next-line
    }, [inputEl]);

    return (
        <div ref={inputEl}>
            <Animate
                start={() => ({
                    value: valueStart,
                })}
                update={() => ({
                    value: [valueEnd],
                    timing: {
                        duration: duration * 1000,
                        ease: easing,
                    },
                })}
            >
                {({ value }) => children(value)}
            </Animate>
        </div>
    );
}
